module.exports = __webpack_public_path__ + "img/dec4.8c30bace.jpg";